import React from 'react'

import BaseModal from '../base-modal'
import { Details, Row, Block } from '../details/details'
import { Button, ButtonRow } from '../buttons'
import moment from 'moment'

const constraints = {
  'width': '760',
  'minWidth': '760px'
}

const titleWithLink = (title, image) => {
  const url = image ? image.url : null
  return (
    <span>
      {title}
      <a href={url} target='_blank' disabled={!url} style={{ marginLeft: '5px' }}>
        View
      </a>
    </span>
  )
}

const ImageBlock = ({ image, title }) => (
  <Block title={titleWithLink(title, image)} style ={{ position: 'relative' }}>
    {
      image ?
        <div className="servicing-images">
          <img src={image.url} style={{ maxWidth:'100%', maxHeight: '75%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
          { image.createdAt && <p className='timestamp'>Uploaded at {moment(image.createdAt).format('MMMM D, YYYY [at] h:mm A')}</p> }
        </div>
        : 
        null
    }
  </Block>
)

export default ({
  servicing: { inspectionImageA = {}, inspectionImageB = {} } = {},
  loading,
  handleClose,
  modalTitle,
}) => (
  <BaseModal
    onClose={handleClose}
    title={modalTitle}
    constraints={constraints}
    contentClassName='issue-create-container'
  >
    {loading ?
      <p>Loading...</p>
      :
      (!inspectionImageA.url && !inspectionImageB.url) ?
        <p>No images</p>
        :
        <Details>
          <Row>
            <ImageBlock title="Inspection Image 1" image={inspectionImageA} />
          </Row>
          <Row>
            <ImageBlock title="Inspection Image 2" image={inspectionImageB} />
          </Row>
        </Details>
    }
  </BaseModal>
)



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-redo-images.js